
<template>
	<div>
		<a href="#" @click="goBack()" v-if="!checkLink" class="back-link">Go Back</a>
	</div>
</template>

<script>
export default {
	name: 'BackLink',
	data() {
		return {
			prevRoute: "",
			checkLink: window.location.href.indexOf("PatientDetails") > -1,
		}
	},
	methods: {
		goBack() {
			history.go(-1);
		}
	}
}
</script>